import { useEffect } from "react";

export default function usePageTitle(title, description) {
    useEffect(() => {
        const fullTitle = title ? `${title} · Lended` : "Lended — Direct MCA Funder. Fast. Reliable. Results.";
        document.title = fullTitle;
        if (description) {
            let meta = document.querySelector('meta[name="description"]');
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute("name", "description");
                document.head.appendChild(meta);
            }
            meta.setAttribute("content", description);
        }
    }, [title, description]);
}
